// Bid ladder: 5,6,7,8,9,10, then the special "mexico" bid worth 20.
export const BID_LADDER = [5, 6, 7, 8, 9, 10, 20] as const;
export type BidValue = (typeof BID_LADDER)[number];

export const MEXICO_BID: BidValue = 20;

export function isMexico(bid: BidValue): boolean {
  return bid === MEXICO_BID;
}

export function nextPossibleBids(currentHighest: BidValue | undefined): BidValue[] {
  if (currentHighest === undefined) return [...BID_LADDER];
  const idx = BID_LADDER.indexOf(currentHighest);
  return BID_LADDER.slice(idx + 1);
}
